import React from "react";

export default function StatsEditor({ value, onChange }) {
  const stats = Array.isArray(value) ? value : [];

  const update = (idx, key, val) => {
    const next = stats.map((s, i) => (i === idx ? { ...(s || {}), [key]: val } : s));
    onChange(next);
  };

  const add = () => onChange([...(stats || []), { value: "", label: "" }]);
  const remove = (idx) => onChange(stats.filter((_, i) => i !== idx));

  return (
    <div className="space-y-3">
      {stats.length === 0 ? (
        <div className="text-xs text-gray-500">No stats yet. Click “Add stat”.</div>
      ) : null}

      {stats.map((s, idx) => (
        <div key={idx} className="p-3 border border-gray-200 rounded-xl bg-white">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <div className="text-xs font-medium text-gray-700">Value</div>
              <input
                value={s?.value ?? ""}
                onChange={(e) => update(idx, "value", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg"
                placeholder="Example: 120%"
              />
            </div>

            <div className="space-y-1">
              <div className="text-xs font-medium text-gray-700">Label</div>
              <input
                value={s?.label ?? ""}
                onChange={(e) => update(idx, "label", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg"
                placeholder="Example: Growth"
              />
            </div>
          </div>

          <div className="flex justify-end mt-3">
            <button
              type="button"
              onClick={() => remove(idx)}
              className="px-3 py-1.5 text-sm rounded-lg border border-red-200 text-red-700 hover:bg-red-50"
            >
              Remove
            </button>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={add}
        className="w-full py-2 rounded-xl border-2 border-dashed hover:bg-gray-50 text-sm font-medium"
      >
        Add stat
      </button>
    </div>
  );
}
